import React, {useEffect, useState} from 'react'
import ReactModal from 'react-modal'

import {cashBoxService} from '../../services/cashbox-service'
import {HCheckbox, HInput, HookForm} from '../../validation/HForm'
import {reasonScheme} from '../../validation/scheme/wordScheme'
import Loader from './Loader/Loader'

import './reasons.scss'

import EditIcon from '../../assets/icons/edit.svg'
import TrashIcon from '../../assets/icons/trash.svg'
import CrossIcon from '../../assets/icons/cross.svg'
import PlusSmallIcon from '../../assets/icons/plus-small.svg'
import LoupeIcon from '../../assets/icons/search.svg'
import DoubleArrowUp from '../../assets/icons/double-arrow-up.svg'
import DoubleArrowDown from '../../assets/icons/double-arrow-down.svg'
import {messages} from "../../helpers/messages";
import {Message} from "../utilites";
import { ConfirmModal } from '../common'


const Reasons = () => {
  const [state, setState] = useState({
    loading: false,
    modalCreate: false,
    modalEdit: false,
    reasons: [],
    name: '',
    entity: null
  })

  const [deleteEntity, setDeleteEntity] = useState(undefined)

  useEffect(() => {
    loadReasons()
  }, [])

  const changeModalState = (name, state, word) => {
    setState(prev => ({
      ...prev,
      [name]: state,
      entity: word,
      error: '',
    }))
  }
  
  const onWordSubmit = entity => {

    let id
    if (state.entity && state.entity.id) {
      id = state.entity.id
    }
    setState(prev => ({
      ...prev,
      error: '',
      loading: true
    }))
    
    let promise
    if (id) {
      promise = cashBoxService.updateReason(id, entity)
    } else {
      promise = cashBoxService.createReason(entity)
    }
    promise.then(response => {
      changeModalState('modalCreate', false)
      changeModalState('modalEdit', false)
      loadReasons(state.name)
    }).catch(error => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages["0"];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        setState(prev => ({
          ...prev,
          error: commonError,
          loading: false
        }))
      }
    })


  }

  const confirmDelete = () => {
    setState(prev => ({
      ...prev,
      error: '',
      loading: true
    }))
    cashBoxService.deleteWord(deleteEntity.id, 'reason').then(response => {
      loadReasons(state.name)
      setDeleteEntity(undefined)
    }).catch(error => {
      setDeleteEntity(undefined)
      setState(prev => ({
        ...prev,
        loading: false
      }))
    })
  }

  const onWordDelete = entity => {
    setDeleteEntity(entity)
  }

  const handleFilter = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.id

    setState(prev => ({
      ...prev,
      [name]: value
    }))
    loadReasons(value)
  }

  const loadReasons = name => {
    setState(prev => ({...prev, error: '', loading: true}))
    cashBoxService.getReasons(name || '').then((response) => {
      setState(prev => ({
        ...prev,
        reasons: response.data.reasons
      }))
    }).finally(() => {
      setState(prev => ({...prev, loading: false}))
    })
  }

  const handlePreventEInInput = e => e.keyCode === 69 && e.preventDefault()

  return (
    <>
      <div className='content-inner-data-container'>
        <div className='content-datatable'>
          <div className='content-datatable-header'>
            <div className='content-datatable-header-left'>
              <div className='action-items'>
                <div className='content-datatable-header-search '>
                  <div className='datatable-search'>
                    <input
                      className='input-small'
                      type='text'
                      placeholder='Поиск…'
                      name='name'
                      id='name'
                      value={state.name}
                      onChange={handleFilter}
                    />
                    <div className='datatable-search-loupe'>
                       <span className='icon'> <LoupeIcon/> </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='content-datatable-header-right'>
              <div className='action-items'>
                <button className='button-icontrigger caption noborder'
                        onClick={() => changeModalState('modalCreate', true)}>
                           <span className='icon'> <PlusSmallIcon/> </span>
                  <span>Добавить</span>
                </button>
              </div>
            </div>
          </div>
          <div className='content-datatable-content'>
            <fieldset>
              {
                state.loading ? <Loader/> :
                    <div className='reason-names'>
                      {state.reasons.map((word, index) => {
                        const {id, name, credit} = word
                        return (<div key={id} className='name handbook-name'>
                          {credit
                              ? <span className={"icon icon-green"}> <DoubleArrowUp/> </span>
                              : <span className={"icon icon-red"}> <DoubleArrowDown/> </span>
                          }
                          <div className='checkbox '>
                            <label htmlFor='1'>
                              <span>{name}</span>
                            </label>
                          </div>
                          <div className='name-actions'>
                            <button className='button-icontrigger noborder'
                                    onClick={() => changeModalState('modalEdit', true, word)}>
                                       <span className='icon'> <EditIcon/> </span>
                            </button>
                            <button className='button-icontrigger noborder' onClick={() => onWordDelete(word)}>
                               <span className='icon'> <TrashIcon/> </span>
                            </button>
                          </div>
                        </div>)
                      })}
                    </div>}
            </fieldset>
          </div>
        </div>
      </div>
      {deleteEntity && <ConfirmModal
        isOpen={!!deleteEntity}
        handleClose={() => {
          setDeleteEntity(undefined)
        }}
        handleAction={confirmDelete}
        headerText='Удаление основания'
        bodyText={`Вы уверены что хотите удалить основание ${deleteEntity.name}?`}/>}
      <ReactModal
        isOpen={state.modalEdit}
        contentLabel='Modal'
        className='modal-container'
        overlayClassName='modal-overlay'
      >
        <HookForm onSubmit={onWordSubmit}
                  validationSchema={reasonScheme}
                  defaultValues={state.entity}
                  submitOnEnterPress = {true}>
          <div className='modal-header'>
            <h2>Редактировать основание</h2>
            <button
              className='button-icontrigger modal-closetrigger'
              onClick={() => changeModalState('modalEdit', false)}>
                            <span className='icon'>
                                <CrossIcon/>
                            </span>
            </button>
          </div>
          <div className='modal-body'>
            {state.error && <Message type={"error"} text={state.error}/>}
            <fieldset>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='itemName'>Название</label>
                <div className='form-element-data'>
                  <HInput className='input' type='text' name='name' id='itemName' h='true'
                          placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='code1C'>Код 1С</label>
                <div className='form-element-data'>
                  <HInput className='input' onKeyDown={handlePreventEInInput} type='number' name='code1C' id='code1C' h='true'
                          placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='code'>Номер корреспондирующего счета, субсчета</label>
                <div className='form-element-data'>
                  <HInput className='input' type='text' name='account' id='code' h='true'
                          placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='credit'>Приходная операция</label>
                <div className='form-element-data'>
                  <HCheckbox h="true" name={'credit'} id='credit'/>
                </div>
              </div>
            </fieldset>
          </div>

          <div className='modal-footer'>
            <button className='button'>Сохранить</button>
            <button className='button-light' type='button'
                    onClick={() => changeModalState('modalEdit', false)}>
              Отменить
            </button>
          </div>
        </HookForm>
      </ReactModal>
      <ReactModal
        isOpen={state.modalCreate}
        contentLabel='Modal'
        className='modal-container'
        overlayClassName='modal-overlay'
      >

        <HookForm onSubmit={onWordSubmit}
                  validationSchema={reasonScheme}
                  defaultValues={state.entity}
                  submitOnEnterPress = {true}>
          <div className='modal-header'>
            <h2>Добавить основание</h2>
            <button className='button-icontrigger modal-closetrigger'
                    onClick={() => changeModalState('modalCreate', false)}>
                            <span className='icon'>
                                <CrossIcon/>
                            </span>
            </button>
          </div>
          <div className='modal-body'>
            {state.error && <Message type={"error"} text={state.error}/>}
            <fieldset>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='itemName'>Название</label>
                <div className='form-element-data'>
                  <HInput className='input' type='text' name='name' id='itemName' h='true'
                          placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='code1C'>Код 1С</label>
                <div className='form-element-data'>
                  <HInput className='input' onKeyDown={handlePreventEInInput} type='number' name='code1C' id='code1C' h='true'
                          placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='code'>Номер корреспондирующего счета, субсчета</label>
                <div className='form-element-data'>
                  <HInput className='input' type='text' name='account' id='code' h='true'
                          placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor='credit'>Приходная операция</label>
                <div className='form-element-data'>
                  <HCheckbox h="true" name={'credit'} id='credit'/>
                </div>
              </div>
            </fieldset>
          </div>
          <div className='modal-footer'>
            <button className='button'>Добавить</button>
            <button className='button-light' type='button'
                    onClick={() => changeModalState('modalCreate', false)}>
              Отменить
            </button>
          </div>
        </HookForm>
      </ReactModal>
    </>
  )
}

export default Reasons
